import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaDetalhamentoDespesas: ['exercicio'],
    setAdministracaoConsultaDetalhamentoDespesas: ['administracao'],
    setOrgaosConsultaDetalhamentoDespesas: ['orgaos'],
    setRecursoConsultaDetalhamentoDespesas: ['recurso'],
    setDestinacaoConsultaDetalhamentoDespesas: ['destinacao'],
    limpaFiltroConsultaDetalhamentoDespesas: [],
    receberFiltroConsultaDetalhamentoDespesas: ['filtroRecebido'],
    setStatusConsultaDetalhamentoDespesas: ['status'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: [],
    orgaos: [],
    recurso: [],
    destinacao: [],
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setOrgaos = (state = INITIAL_STATE, action) => {
    return { ...state, orgaos: action.orgaos }
}

const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}

const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_DETALHAMENTO_DESPESAS]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_DETALHAMENTO_DESPESAS]: setAdministracao,
    [Types.SET_ORGAOS_CONSULTA_DETALHAMENTO_DESPESAS]: setOrgaos,
    [Types.SET_RECURSO_CONSULTA_DETALHAMENTO_DESPESAS]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_DETALHAMENTO_DESPESAS]: setDestinacao,
    [Types.LIMPA_FILTRO_CONSULTA_DETALHAMENTO_DESPESAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_DETALHAMENTO_DESPESAS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_DETALHAMENTO_DESPESAS]: setStatus,
})
